<template>
    <div class="facebookPosts">
        <template v-for="post in facebookPosts" :key="post.id">
            <Animate>
                <div class="facebookPosts__item">
                    <template v-if="post.message">
                        <div class="facebookPosts__item-header">
                            <div class="facebookPosts__item-header-author">
                                <div
                                    class="facebookPosts__item-header-author-image"
                                >
                                    <svg
                                        width="35"
                                        height="35"
                                        viewBox="0 0 90 90"
                                    >
                                        <path
                                            d="M5.8112 22.8728C5.93503 22.8019 6.11486 22.7061 6.38437 22.5926C6.74479 22.4406 7.27123 22.2543 7.9479 22.1315C8.32052 22.0639 8.73611 22.0159 9.30762 22.0025C9.76888 21.9917 10.9287 21.9902 12.4391 22.2855C13.9085 22.5727 15.0021 23.0022 15.5116 23.2186C15.989 23.4215 17.0007 23.8781 18.1676 24.6705C18.6845 25.0217 19.8693 25.8713 21.3913 27.5709C22.3832 28.6785 23.1387 29.7232 24.4991 31.874C25.6335 33.667 26.7549 35.4397 28.1655 38.0628C29.4133 40.383 31.0145 43.6048 31.8638 45.6177C31.9337 45.7838 32.4006 46.8943 33.0702 48.2404C33.4622 49.0279 33.7312 49.5098 33.8472 49.715C34.2073 50.3519 34.3876 50.6702 34.6485 51.0688C35.2318 51.9592 35.5389 52.2348 35.4336 52.3984C35.2974 52.61 34.5807 52.4644 34.5595 52.3017C34.5506 52.2331 34.6613 52.1546 36.081 51.6248C36.7409 51.3786 37.1117 51.2415 37.6674 51.0446C38.6353 50.7016 38.6233 50.6702 39.2214 50.4644C40.1048 50.1601 40.7627 50.0262 41.2934 49.8842C44.3722 49.0602 43.1729 49.3667 45.1952 48.8323C47.6254 48.1903 48.8406 47.8692 50.1963 47.5312C52.3491 46.9943 53.8683 46.656 56.6064 46.0484C60.1913 45.2529 61.9838 44.8551 63.8581 44.5012C67.6949 43.7767 70.6062 43.3884 71.4661 43.2764C73.1429 43.058 74.6415 42.9087 77.6389 42.6105C79.0976 42.4653 77.7086 42.6128 79.3006 42.4705C81.6114 42.2641 82.9144 42.0984 84.2527 42.6105C84.3776 42.6583 85.0297 42.9136 84.9986 43.0507C84.9751 43.1546 84.5744 43.1306 84.0921 43.1474C83.831 43.1565 83.312 43.2338 82.2738 43.3882C79.4413 43.8096 76.9099 44.3215 76.9099 44.3215C69.9978 45.6531 60.662 47.8992 60.662 47.8992C60.662 47.8992 51.5533 50.2604 40.6646 54.1729C39.7864 54.4885 38.8865 54.8664 38.5415 55.0093C38.1148 55.1861 37.5685 55.3744 36.8904 55.7506C36.6144 55.9035 36.3928 56.043 36.243 56.1374C35.0706 56.8764 34.9225 57.1708 34.6242 57.1044C34.3913 57.0525 34.3079 56.8429 33.815 55.8473C33.3655 54.9396 33.6034 55.5421 33.1351 54.5579C32.1635 52.5166 30.8496 49.3251 29.4681 46.551C29.4277 46.4698 29.4357 46.4862 28.4083 44.5335C24.5827 37.2609 24.5426 37.1658 24.1563 36.4922C22.0069 32.7455 20.2216 30.4251 19.7819 29.8555C19.1357 29.0183 17.7876 27.3249 15.7199 25.552C14.1455 24.2019 13.0895 23.6083 12.0225 23.2186C10.7707 22.7618 9.71037 22.6723 9.30762 22.6471C8.76138 22.6131 8.00798 22.5717 7.0738 22.7761C5.85862 23.0421 5.04689 23.5689 5.00182 23.4853C4.96615 23.419 5.46353 23.0722 5.8112 22.8728Z"
                                            fill="#C51E25"
                                        />
                                        <path
                                            d="M54.6315 61.1497C54.6315 64.3806 52.0008 67 48.7556 67C45.5105 67 42.8796 64.3806 42.8796 61.1497C42.8796 57.9186 45.5105 55.2994 48.7556 55.2994C52.0008 55.2994 54.6315 57.9186 54.6315 61.1497Z"
                                            fill="#C51E25"
                                        />
                                        <path
                                            d="M81.146 54.3324C81.146 56.9493 79.0153 59.0707 76.387 59.0707C73.7586 59.0707 71.6279 56.9493 71.6279 54.3324C71.6279 51.7156 73.7586 49.5941 76.387 49.5941C79.0153 49.5941 81.146 51.7156 81.146 54.3324Z"
                                            fill="#C51E25"
                                        />
                                    </svg>
                                </div>
                                <div
                                    class="facebookPosts__item-header-author-name"
                                >
                                    Retail Only
                                    <p
                                        class="facebookPosts__item-header-author-created"
                                    >
                                        {{ post.created }}
                                    </p>
                                </div>
                            </div>
                            <a
                                :href="post.permalink"
                                class="facebookPosts__item-header-link"
                                target="_blank"
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M21 12L14 5V9C7 10 4 15 3 20C5.5 16.5 9 14.9 14 14.9V19L21 12Z"
                                        fill="#c42126"
                                    />
                                </svg>
                                <span>Läs mer och kommentera på Facebook</span>
                            </a>
                        </div>
                        <div class="facebookPosts__item-message">
                            {{ post.message }}
                        </div>
                        <div
                            class="facebookPosts__item-picture"
                            v-if="post.picture"
                        >
                            <img :src="post.picture" alt="Facebook image" />
                        </div>
                    </template>
                </div>
            </Animate>
        </template>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'

import axios from 'axios'

import Animate from '@/components/Common/Animate.vue'

interface FacebookPost {
    id: string
    created: string
    message: string
    permalink: string
    picture: string
}

export default defineComponent({
    name: 'FacebookPosts',
    components: {
        Animate,
    },
    setup() {
        let facebookPosts = ref([] as FacebookPost[])
        const url =
            process.env.NODE_ENV === 'production'
                ? 'https://node.retailonly.se'
                : 'http://192.168.1.11:5500'

        const fetchFacebookPosts = async () => {
            const result = await axios.get(`${url}/facebookPosts?limit=20`)

            if (!result) return
            facebookPosts.value = result.data.data.filter(
                (post) => post.message
            )
        }

        onMounted(fetchFacebookPosts)

        return {
            facebookPosts,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins';

.facebookPosts {
    margin-top: 4rem;

    &__item {
        margin-bottom: 6rem;
        border-radius: 10px;
        box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.05);
        border-top: 4px solid $accent-color-very-light;

        @include mQ(700px) {
            margin-bottom: 4rem;
            border-top: 2px solid $accent-color-very-light;
        }

        &-picture {
            box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.05);

            & img {
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                display: block;
                width: 100%;
                height: auto;
                max-height: 800px;
                object-fit: cover;
                object-position: center;

                @include mQ(700px) {
                    max-height: 350px;
                }
            }
        }

        &-message {
            background-color: lighten($accent-color-very-light, 4%);
            padding: 2rem;
            white-space: pre-line;
            line-height: 1.6;

            @include mQ(700px) {
                padding: 1rem;
            }
        }

        &-header {
            display: flex;
            padding: 1.5rem;

            @include mQ(700px) {
                padding: 1rem 1rem 0 1rem;
            }

            &-link {
                display: flex;
                align-items: center;
                margin-left: auto;
                color: $accent-color;

                @include mQ(700px) {
                    font-size: 0.9rem;
                }

                & svg {
                    height: 24px;
                    width: 24px;

                    @include mQ(700px) {
                        height: 40px;
                        width: 40px;
                        margin-bottom: 1rem;
                    }
                }

                & span {
                    margin-left: 0.3rem;

                    @include mQ(700px) {
                        display: none;
                    }
                }
            }

            &-author {
                display: flex;
                align-items: center;

                @include mQ(700px) {
                    margin-bottom: 1rem;
                }

                &-image {
                    border-radius: 50%;
                    background-color: #fff;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid $accent-color;
                }

                &-name {
                    margin-left: 0.6rem;
                    font-size: 1rem;
                }

                &-created {
                    color: $font-color-main-med-grey;
                    font-size: 0.8rem;
                    text-transform: uppercase;
                }
            }
        }
    }
}
</style>
